export default __webpack_public_path__ + "static/media/banner-characters.1a5168fa.mp4";